import { render, staticRenderFns } from "./CostPerSectorCalc.vue?vue&type=template&id=a991cea6&scoped=true&lang=html&"
import script from "./CostPerSectorCalc.vue?vue&type=script&lang=js&"
export * from "./CostPerSectorCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991cea6",
  null
  
)

export default component.exports